import {
  Component,
  OnInit,
  ViewEncapsulation,
  ChangeDetectorRef,
  TemplateRef,
  ViewChild,
  OnDestroy,
} from '@angular/core';

import { DomSanitizer } from '@angular/platform-browser';
import { PoliciesService } from './policies.service';
import { Router } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MatTableDataSource } from '@angular/material';
import { Subscription } from 'rxjs';
import { TableKeyEnum } from '../../../core/enum/table-key.enum';
import { SearchService } from '../../../services/search.service';
import { SearchControlTypeEnum, SearchDataTypeEnum } from '../../../core/enum/searchType.enum';
import { OldAbstractBaseListComponent } from '../../../components/base/old-abstract-base-list-component';
import { AclClassConstants } from '../../aclClassConstants';
import { AclConstants } from '../../aclOperationConstants';
import { LoginService } from '../../login/login.service';
import { ToastrService } from 'ngx-toastr';
import { SearchData } from '../../../core/modal/search-data';

@Component({
  selector: 'app-policies',
  templateUrl: './policies.component.html',
  styleUrls: ['./policies.component.scss'],
})
export class PoliciesComponent extends OldAbstractBaseListComponent implements OnInit, OnDestroy {
  @ViewChild('statusWrapper', { static: false }) statusWrapperRef: TemplateRef<any>;
  @ViewChild('actionBtn', { static: false }) actionBtnRef: TemplateRef<any>;
  @ViewChild('policies', { static: false }) policiesReff: TemplateRef<any>;
  AclClassConstants = AclClassConstants;
  AclConstants = AclConstants;

  policiesDataForGrid: any = { content: [] };
  policiesGridSettings: any = {};
  show_update: any = false;
  selectForUpdate: any;
  tableKeyEnum = TableKeyEnum;
  allColumns: any[] = [];
  dataSource = new MatTableDataSource([]);
  filteredData = [];
  filteredPoliciesDataForGrid : any = [];
  insertPoliciesForm = new FormGroup({
    policies_name: new FormControl('', [Validators.required]),
    status: new FormControl('', [Validators.required]),
  });
  // For advance search
  searchSettings = [];
  subscriptions: Subscription[] = [];
  dynaauthpolicies:boolean;
  public loginService: LoginService;
  serverFilterObj: SearchData[] = [];
  constructor(
    private policiesService: PoliciesService,
    private router: Router,
    private sanitizer: DomSanitizer,
    private cdRef: ChangeDetectorRef,
    private searchService: SearchService,
    private tosterservice : ToastrService,
    loginService: LoginService
  ) {
    super(searchService);
    this.loginService=loginService;
  }

  ngOnInit() {
    if(this.searchService.serverFilterObj && this.searchService.serverFilterObj.length > 0){
      this.searchService.resetGlobalSearchServerFilterObj();
    }
    let URL  = this.router.url.includes('dynaauthpolicies')
    if(URL){
      this.dynaauthpolicies = true
      this.policiesService.dynaauthpolicies = true
    }else{
      this.dynaauthpolicies = false
      this.policiesService.dynaauthpolicies = false
    }
    this.setDefaultPageSize(this.tableKeyEnum.POLICIES_LIST)
    const filterSubscription = this.searchService.getFilterOptions().subscribe((obj) => {
      console.log("obj--",obj)
       if (obj && obj.filters) {
      this.applyFilter(obj);
       }
    });
    this.setGridSetting();
    this.setDefaultOrder();
    this.searchData = new SearchData();
    let obj = {
      filterColumn: 'policyType',
      filterValue:  null,
    }
    if(this.dynaauthpolicies){
      obj.filterValue = 'DynaAuth'
    }
    else{
      obj.filterValue = 'Radius'
    }
    this.onFilterChange(obj);
    //this.initPaginationSort();
    this.subscriptions.push(filterSubscription);
    
  }

  setGridSetting() {
    let self = this;
    if(!this.dynaauthpolicies){
    this.allColumns = [
      { colKey: 'index', default: 'ID', rowKey: 'id', width: '3%', isFilterAllow: false, isNumber: true },
      {
        colKey: 'policies_name',
        default: 'Policies Name',
        rowKey: 'policies_name',
        width: '10%',
        isNumber: false,
        isFilterAllow: true,
        enableEdit: true,
        enableDelete: true,
        enableSort: true,
      },
      {
        colKey: 'status',
        default: 'STATUS',
        rowKey: 'status',
        width: '10%',
        customControls: [this.statusWrapperRef],
        customValue:(status) => {
          if(status === '1'){
            return 'Active';
          } else {
            return 'InActive';
          }
        },
        isNumber: false,
        isFilterAllow: true,
        enableEdit: true,
        enableDelete: true,
        enableSort: true,
      },
      {
        colKey: 'updatedate',
        default: 'Last Modified',
        rowKey: 'updatedate',
        width: '10%',
        isNumber: false,
        isFilterAllow: true,
        enableEdit: true,
        enableDelete: true,
        enableSort: true,
      },
      {
        colKey: 'actionCol',
        default: 'Action',
        rowKey: 'id',
        //enableEdit: true,
        // enableDelete: true,
        enableEdit: false,
        enableDelete: false,
        isFilterAllow: false,
        enableSort: false,
        isExpandable: false,
        isNumber: false,
        width: '1%',
        isStickyEnd: true,
      },
    ];
  }else{
    this.allColumns = [
      { colKey: 'index', default: 'ID', rowKey: 'id', width: '3%', isFilterAllow: false, isNumber: true },
      {
        colKey: 'policies_name',
        default: 'Policies Name',
        rowKey: 'policies_name',
        width: '10%',
        isNumber: false,
        isFilterAllow: true,
        enableEdit: true,
        enableDelete: true,
        enableSort: true,
      },
      {
        colKey: 'dynaAuthType',
        default: 'Dynamic Auth Policy Type',
        rowKey: 'dynaAuthType',
        width: '10%',
        isNumber: false,
        isFilterAllow: true,
        enableEdit: true,
        enableDelete: true,
        enableSort: true,
      },
      {
        colKey: 'status',
        default: 'STATUS',
        rowKey: 'status',
        width: '10%',
        customControls: [this.statusWrapperRef],
        customValue:(status) => {
          if(status === '1'){
            return 'Active';
          } else {
            return 'InActive';
          }
        },
        isNumber: false,
        isFilterAllow: true,
        enableEdit: true,
        enableDelete: true,
        enableSort: true,
      },
      {
        colKey: 'updatedate',
        default: 'Last Modified',
        rowKey: 'updatedate',
        width: '10%',
        isNumber: false,
        isFilterAllow: true,
        enableEdit: true,
        enableDelete: true,
        enableSort: true,
      },
      {
        colKey: 'actionCol',
        default: 'Action',
        rowKey: 'id',
        //enableEdit: true,
        // enableDelete: true,
        enableEdit: false,
        enableDelete: false,
        isFilterAllow: false,
        enableSort: false,
        isExpandable: false,
        isNumber: false,
        width: '1%',
        isStickyEnd: true,
      },
    ];
  }
    this.allColumns.forEach(element => {
      element.isFilterAllow = false;
    });
    this.searchSettings = [
      {
        display_field: 'Status',
        value_field: 'status',
        control_setting: [
          {
            control_type: SearchControlTypeEnum.SELECT,
            display_style: '',
          },
        ],
        data_type: SearchDataTypeEnum.BOOLEAN,
        select_items: [
          {
            display_field: 'All',
            value_field: ['1', '0'],
          },
          {
            display_field: 'Active',
            value_field: '1',
          },
          {
            display_field: 'In Active',
            value_field: '0',
          },
        ],
      },
      {
        display_field: 'Policies Name',
        value_field: 'policies_name',
        control_setting: [
          {
            control_type: SearchControlTypeEnum.TEXT,
            display_style: '',
          },
        ],
        data_type: SearchDataTypeEnum.STRING,
      },
    ];

    this.policiesGridSettings = {
      showAdvanceSearch: false,
      showFooter: false,
      showPagination: true,
      tableId: this.tableKeyEnum.POLICIES_LIST,
      perPage: this.paginationData.rowsPerPage,
      pageNumber:this.paginationData.pageNumber - 1,
      pageSizeOptions: [5, 10, 15, 20, 50, 100],
      serverSideSortPagination: true,
      serverSideFilter: true,
      pageTotalLength: 0,
      sort: true,
      defaultSortCol: '',
      defaultSortDirection: 'asc',
      columns: this.allColumns,
      deleteMsgBoxTitle: 'Are you sure to delete this Policies?',
      deleteMsgBoxDetail: '"Policies Name :${policies_name} " ',
    };
    if (this.policiesGridSettings.serverSideSortPagination && this.policiesGridSettings.perPage) {
      this.setPaginationPerPage(this.policiesGridSettings.perPage);
    }
  }

  applyFilter(filterObj) {
    
    let filteredDataForGrid = JSON.parse(JSON.stringify(this.policiesDataForGrid.content));
    console.log("filteredDataForGrid---",filteredDataForGrid)
    if (filterObj && filterObj.filters) {
      // Client Side Filter
          filteredDataForGrid = this.searchService.getFilteredData(filterObj.filters, this.policiesDataForGrid.content);
    }
    
    this.refreshDataSource(filteredDataForGrid);
  }

  refreshDataSource(data) {
    if (data) {
        console.log("Data------",data)
      this.dataSource = new MatTableDataSource(JSON.parse(JSON.stringify(data)));
    }
  }

  ngAfterViewInit() {
    this.allColumns.forEach((col) => {
      if (col.colKey == 'status') {
        col.customControls = [this.statusWrapperRef];
      }
      if (col.colKey == 'actionCol') {
        col.customControls = [this.actionBtnRef];
      }
      if (col.colKey == 'policies_name') {
        col.customControls = [this.policiesReff];
      }
    });
  }

  getPoliciesData(gridSetting : any) {
    let fetchSettingData = this.policiesGridSettings.serverSideSortPagination ? gridSetting : null;
    let params = this.getGridSettingInfo(fetchSettingData);
    
    this.policiesService.getPoliciesDataWithPageing(params).subscribe((result) => {
      this.policiesDataForGrid = result;
      this.filteredPoliciesDataForGrid = JSON.parse(JSON.stringify(this.policiesDataForGrid.content));
      this.refreshDataSource(this.policiesDataForGrid.content);
      this.totalRecords = result.pageDetails ? result.pageDetails.totalRecords : 0;
      this.policiesGridSettings.pageTotalLength = this.totalRecords;
    });
  }

  getListWithParams() {
    if(Array.isArray(this.searchData)){
      let obj = this.searchData.filter(res=>res.filterColumn == 'any')
      if(this.searchData.length > 1){
        if(this.dynaauthpolicies){
          this.searchData[0].filterCondition = 'DynaAuth'
        }else{
          this.searchData[0].filterCondition = 'Radius'
        }
        if(this.searchData[0].filterValue && this.searchData[0].filterValue !== ''){
          this.paginationData.pageNumber = 1;
       }
      }
    }
    let config = { page: this.paginationData, order: this.orderingData, search: this.searchData };
    this.getPoliciesData(config);
  }

  delete(objEvent) {
    let self = this;
    let selected_policies_data = objEvent.event;
    if (objEvent.deleteClicked) {
    this.policiesService.deletePolicies(selected_policies_data.policies_id).subscribe((result) => {
      if(result.status !== 200){
        this.tosterservice.error(result.ERROR);
      }
      else{
        this.tosterservice.success('Policies is deleted successfully');
        this.show_update = false;
        this.policiesDataForGrid.content.forEach(function (item, index) {
          if (item.policies_id === selected_policies_data.policies_id) {
            self.policiesDataForGrid.content.splice(index, 1);
          }
        });
        self.refreshDataSource(self.policiesDataForGrid.content);
      }
    
    },
    err => {
      this.tosterservice.error(err.error.status + " " + err.error.ERROR);
    });
   }
  }

 // onEdit(event) {
  //   this.setUpdateValueInForm(event.RowData);
  // }

  onEdit(event) {
    ////console.log(event);
    this.setUpdateValueInForm(event);
  }

  // onDelete(event) {
  //   let self = this;
  //   if (event.deletClicked) {
  //     self.delete(event.RowData);
  //   }
  // }

  onDelete(event) {
     if (event) {
       this.commonDeleteMsgBox(this.policiesGridSettings,event,this.delete.bind(this));
     }
  }

  onAddPoliciesClick() {
    if(this.dynaauthpolicies){
      this.router.navigate(['/radius/policies/add-dynaauthpolicies']);
    }else{
      this.router.navigate(['/radius/policies/add-policies']);
    }
    
  }

  setUpdateValueInForm(rowData) {
    if(this.dynaauthpolicies){
      this.router.navigate(['/radius/policies/add-dynaauthpolicies',rowData.policies_id]);
    }
    else{
      this.router.navigate(['/radius/policies/add-policies',rowData.policies_id]);
    }
  }

  ngOnDestroy() {
    //this.onFilterChange(null);
    let serverFilterObj = JSON.parse(JSON.stringify(this.serverFilterObj));
    serverFilterObj = this.serverFilterObj.filter((fObj) => {
      return null;
    });
    this.serverFilterObj = serverFilterObj;
    this.searchService.setServerFilterObj(this.serverFilterObj);
    if (this.subscriptions.length > 0) {
      this.subscriptions.map((subscription) => {
        subscription.unsubscribe();
      });
    }
  }
  setPagination(event){
    let config = { page: event, order: this.orderingData, search: this.searchData };
    this.getPoliciesData(config);
      }
}
